import * as React from "react";
import { Button, Paper } from "@mui/material";
import cookie from "../../../API/cookie";

var pt;
var g_recv_idx = 0;
var defaultValue;

//user_id cookie
let user_id = cookie.getCookie("userAccount")
  ? cookie.getCookie("userAccount")
  : "";
var api_token = cookie.getCookie("accessToken");

if (user_id) {
  defaultValue = {
    key: api_token,
  };
}

export default function ExperimentMachinePageMiddle(props) {
  function handleprops( //센서데이터 몰래 저장시 필요, 저장 안할시 bluetoothService(기기정보), starttime(타이머) 전달
    t,
    bluetoothService,
    starttime,
    firmwareVersion
  ) {
    props.propFunction(t, bluetoothService, starttime, firmwareVersion);
  }

  var bluetoothService = null;

  DataView.prototype.getUint24 = function (pos) {
    return (this.getUint16(pos) << 8) + this.getUint8(pos + 2);
  };
  DataView.prototype.getInt24 = function (pos) {
    return (this.getInt16(pos) << 8) + this.getUint8(pos + 2);
  };

  const CURRENT_SERVICE_UUID = "6e400001-b5a3-f393-e0a9-e50e24dcca9e";
  const NOTIFY_UUID = "6e400003-b5a3-f393-e0a9-e50e24dcca9e";
  const WRITE_UUID = "6e400002-b5a3-f393-e0a9-e50e24dcca9e";
  const BAS_SERVICE_UUID = "0000180f-0000-1000-8000-00805f9b34fb";
  const BAS_LEVEL_UUID = "00002a19-0000-1000-00805f9b34fb";

  const DIS_SERVICE_UUID = "0000180a-0000-1000-8000-00805f9b34fb";
  const FW_REV_UUID = "00002a26-0000-1000-8000-00805f9b34fb";

  let options = {
    filters: [{ services: [CURRENT_SERVICE_UUID] }],
    optionalServices: ["generic_access", BAS_SERVICE_UUID, DIS_SERVICE_UUID], 
  };


  let batteryChar;
  let nusNotifyChar;
  let batteryPollTimer = null;

  async function connectDevice() {
    var starttime = new Date();
    const device = await navigator.bluetooth.requestDevice(options);
    const server = await device.gatt.connect();

    // NUS와 BAS를 병렬로 잡아오기
    const [nusService, basService, disService] = await Promise.all([
      server.getPrimaryService(CURRENT_SERVICE_UUID),
      server.getPrimaryService(BAS_SERVICE_UUID).catch(() => null),
      server.getPrimaryService(DIS_SERVICE_UUID).catch(() => null),
    ]);

    let fwRev = null;
    if (disService) {
      try {
        const fwChar = await disService.getCharacteristic(FW_REV_UUID);
        const v = await fwChar.readValue();
        fwRev = new TextDecoder().decode(v).trim();
        console.log("[BLE] firmwareRevision:", fwRev);
      } catch (e) {
        console.warn("[BLE] FW revision read failed:", e);
      }
    }

    try {
      nusService._fwRev = fwRev;
    } catch {}

    // --- NUS: Write 한 번 보내기 (기존 로직 유지) ---
    const writeChar = await nusService.getCharacteristic(WRITE_UUID);
    const initCmd = new TextEncoder().encode("910|1");
    await writeChar.writeValueWithoutResponse(initCmd);

    const stableCmd = new TextEncoder().encode("919|2");
    await writeChar.writeValueWithoutResponse(stableCmd);


    // --- NUS: Notify 시작 (기존 로직 유지) ---
    nusNotifyChar = await nusService.getCharacteristic(NOTIFY_UUID);
    await nusNotifyChar.startNotifications();
    nusNotifyChar.addEventListener(
      "characteristicvaluechanged",
      onNusNotification(nusService, starttime)
    );

    // --- BAS: Battery Level notify/poll 설정 ---
    if (basService) {
      try {
        batteryChar = await basService.getCharacteristic(BAS_LEVEL_UUID);

        if (batteryChar.properties.notify) {
          await batteryChar.startNotifications();
          batteryChar.addEventListener(
            "characteristicvaluechanged",
            onBatteryLevel
          );
          // 최초 값 한 번 읽어 UI 즉시 반영
          const v = await batteryChar.readValue();
          onBatteryLevel({ target: { value: v } });
        } else {
          // notify 미지원 → 주기 폴링 (예: 60초)
          const poll = async () => {
            try {
              const v = await batteryChar.readValue();
              onBatteryLevel({ target: { value: v } });
            } catch (e) {
              console.warn("Battery read failed:", e);
            }
          };
          await poll();
          batteryPollTimer = setInterval(poll, 60000);
        }
      } catch (e) {
        console.warn("BAS characteristic not available:", e);
      }
    }

    // 필요 시 disconnect 핸들링
    device.addEventListener("gattserverdisconnected", () => {
      if (batteryPollTimer) {
        clearInterval(batteryPollTimer);
        batteryPollTimer = null;
      }
    });
  }

  // --- 핸들러들 ---
  function onNusNotification(service, time) {
    // 기존 로직: 부모로 넘기기
    handleprops(0, service, time, service?._fwRev ?? null);
  }

  function onBatteryLevel(event) {
    const dv = event.target.value; // DataView
    const level = dv.getUint8(0); // 0~100
    console.log("Battery Level:", level, "%");
  }

  return (
    <Paper
      style={{
        // height: "100vh",  ← 이거 제거
        width: "100%",
        backgroundColor: "#131313",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",  // 위에서부터 시작
        alignItems: "center",
        padding: "16px",
        paddingTop: "8vh",             // 헤더 아래로 살짝 내려오기
        boxSizing: "border-box",
        textAlign: "center",
        flexGrow: 1,                   // 남는 영역 채우기
      }}
    >
      <h3
        style={{
          color: "white",
          fontFamily: "GmarketSansMedium",
          margin: 0,
          marginBottom: 24,
          maxWidth: 480,
          lineHeight: 1.5,
          fontSize: "1rem",
        }}
      >
        블루투스 기기의 전원을 켜고 아래의 Connect 버튼을 눌러 기기를
        연결해주세요.
      </h3>
      <Button
        onClick={connectDevice}
        style={{
          color: "white",
          fontFamily: "GmarketSansMedium",
          minWidth: 160,
        }}
        variant="contained"
      >
        Connect
      </Button>
    </Paper>
  );
}